export default __webpack_public_path__ + "static/media/Shaka_particle_final_12.43808453.png";